import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  Renderer2,
  viewChild
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { DominantColorSvgPipe } from '../../pipes/dominantColorSvg.pipe';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { BaseComponent } from '../../abstract-components/base.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'customer-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    LazyLoadImageModule,
    DominantColorSvgPipe,
    NgScrollbarModule
  ],
  templateUrl: './customer-layout.component.html',
  styleUrl: './customer-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomerLayoutComponent
  extends BaseComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  protected _renderer = inject(Renderer2);

  asideElRef = viewChild('aside', { read: ElementRef<HTMLElement> });
  footerElRef = viewChild('footer', { read: ElementRef<HTMLElement> });

  currentYear = new Date().getFullYear();

  ngOnInit() {
    if (this._isPlatformBrowser) {
      this._renderer.addClass(document.body, 'customer-layout');
    }
  }

  ngAfterViewInit(): void {
    this._setAsideElHeight();
  }

  ngOnDestroy() {
    if (this._isPlatformBrowser) {
      this._renderer.addClass(document.body, 'customer-layout');
    }
  }

  private _setAsideElHeight(): void {
    const asideEl = this.asideElRef()?.nativeElement as HTMLElement | null;
    const footerEl = this.footerElRef()?.nativeElement as HTMLElement | null;

    if (!(asideEl && footerEl)) return;

    const height = `calc(100dvh - ${footerEl.offsetHeight}px)`;
    asideEl.style.height = height;
  }
}
